import { cn } from "@utils/tailwind-merge";
import { Link } from "react-router-dom";
import medalImage from "@assets/icon/medal.png";
import { useTranslation } from "react-i18next";

interface ToDonationNavigationProps {
  className ?: string;
  shape?: "smooth" | "round" | "square";
}

export function GoToDonation(props: ToDonationNavigationProps){
  const {t} = useTranslation();
  return (
    <Link
      to={"/donation"} 
      className={cn(
        "bg-warning hover:bg-warning/90 active:bg-warning/80 inline-flex",
        "items-center gap-3 px-5 py-1.5 text-secondary-dark",
        "uppercase",
        {
          "rounded-full": props.shape === "round",
          "rounded-lg": props.shape === "smooth" || !props.shape,
          "rounded-none": props.shape === "square",
        },
        props.className
      )}
      data-testid="donation-goToDonation-link"
    >
      <img src={medalImage as string} alt="" className="h-5" />
      {t("features.donation.go_to_donation.button_text")}
    </Link>
  )
}